export const tagline = [
  'Unlikely',
  'is',
  'a',
  'technology',
  'studio',
  'creating',
  'bespoke',
  'digital',
  'experiences',
  'for',
  'brands.',
]

export const clients = [
  'Martell',
  'Icicle',
  'Period Paris',
  'Rudi Gernreich',
  'Initiatives Coeur',
  'Natixis',
  'Dassault Systèmes',
  'ESB',
  'Caisse d’Epargne',
  'Colas',
  'Eco-Emballages',
  'Foncière-Active',
  'Chanel',
  'Etam',
  'Dolce Gabbana',
  'Elie Saab',
  'Pernod Ricard',
  'ARPP',
  'Deutz',
  'Magasins Généraux',
  'Chaumet',
  'Midori',
  'Uzik',
  'BETC',
  'TBWA',
  'Zee Agency',
  'Wondr',
  'New Science',
  'Josiane',
  'Source Interactive',
  'Goodkids',
  'Elevate',
  'Influence',
  'Bold+Beyond',
  'Air France',
  'Decathlon',
]

export const projects = [
  {
    name: 'Air France - French Tech',
    desc: 'BETC x Unlikely',
    src: 'videos/airfrance_encoded.mp4',
    still: 'stills/airfrance.jpg',
    url: 'https://frenchtech.airfrance.com/',
    clickable: true,
  },
  {
    name: 'World of Chaumet',
    desc: 'Zee Agency x Unlikely',
    src: 'videos/chaumet_encoded.mp4',
    still: 'stills/chaumet.jpg',
    url: 'https://exhibition-tokyo.chaumet.com/en/',
    clickable: true,
  },
  {
    name: 'Deutz - Website',
    desc: 'Josiane x Unlikely',
    src: 'videos/deutz_encoded.mp4',
    still: 'stills/deutz.jpg',
    url: 'https://www.champagne-deutz.com/en/',
    clickable: true,
  },
  {
    name: "Wed'ze - Stream 550",
    desc: 'Decathlon x Unlikely',
    src: 'videos/stream_encoded.mp4',
    still: 'stills/stream.jpg',
    url: 'http://stream550.wedze.com/uk/',
    clickable: true,
  },
  {
    name: 'Magasins Généraux',
    desc: 'BETC x Unlikely',
    src: 'videos/mg_encoded.mp4',
    still: 'stills/magasinsgeneraux.jpg',
    url: 'https://magasinsgeneraux.com/fr/',
    clickable: true,
  },
  {
    name: 'Metropolis - Website',
    desc: 'Metropolis x Unlikely',
    src: 'videos/metropolis_encoded.mp4',
    still: 'stills/metropolis.jpg',
    url: 'http://metropolis.watch/',
    clickable: true,
  },
  {
    name: 'Carv Wearable - Landing',
    desc: 'Carv x Unlikely',
    src: 'videos/carv_encoded.mp4',
    still: 'stills/carv.jpg',
    url: 'http://carv.unlikely.work/',
    clickable: true,
  },
  {
    name: 'Oxford House - Website',
    desc: 'Oxford House x Unlikely',
    src: 'videos/oxford_encoded.mp4',
    still: 'stills/oxford.jpg',
    url: 'http://oxfordhouse.nl/',
    clickable: true,
  },
  {
    name: 'Eagle Films - Website',
    desc: 'Eagle Films x Unlikely',
    src: 'videos/eagle_encoded.mp4',
    still: 'stills/eaglefilms.jpg',
    clickable: false,
  },
  {
    name: 'TBWA\\Groupe',
    desc: 'TBWA x Unlikely',
    src: 'videos/tbwagroupe.mp4',
    still: 'stills/tbwagroupe.jpg',
    url: 'https://www.tbwa-groupe.com/',
    clickable: true,
  },
]
